<div class="projects" >
    

            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" data-bs-toggle="tab" href="#resultados2025">Resultados 2025</a>
                </li>
                    <li class="nav-item">
                    <a class="nav-link" data-bs-toggle="tab" href="#resultados2024">Resultados 2024</a>
                </li>
            </ul>

            <div id="myTabContent" class="tab-content">
                <div class="tab-pane fade show active" id="resultados2025">
                    <div style="padding: 20px 50px;">
                        <div class="row">
                        <app-seicep-resultados2025> </app-seicep-resultados2025>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade show" id="resultados2024">
                <div style="padding: 20px 50px;">
                    <div class="row">
                        <app-seicep-resultados2024></app-seicep-resultados2024>
                    </div>
                </div>
                </div>

            </div>

</div>
